// Раздел «Заявки и ремонты» старого Office (dict/client-request-list, dict/remont-list).
// Ключи pages = menu_action пунктов меню (office_api/office_port/areas/requests/endpoints.py, MENU).
// Быстрый поиск и Журнал договоров уже были в My Space (quickSearch, agreementsJournal) — пункты меню ведут туда.
const reqStatuses = { All: -1, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8 };
const remontKeys = {
  "1_1": "1/1", "1_2": "1/2", "1_3": "1/3", "1_4": "1/4", "1_5": "1/5", "1_6": "1/6", "1_0": "1/0",
  2: "2", 3: "3", 4: "4",
};

export const pages = {
  officeReqRemarketAll: "/office/requests/remarket/-2",
  officeReqRemarket1: "/office/requests/remarket/1",
  ...Object.fromEntries(Object.entries(reqStatuses).map(([k, v]) => [`officeReqList${k}`, `/office/requests/list/${v}`])),
  ...Object.fromEntries(Object.entries(remontKeys).map(([k, v]) => [`officeRemontList${k}`, `/office/requests/remonts/${v}`])),
};

export const routes = [
  {
    path: "/office/requests/list/:status_id?",
    name: "officeReqList",
    meta: { layout: "main", title: "Заявки на ремонт" },
    component: () => import("@/views/office/requests/ClientRequestList.vue"),
  },
  {
    path: "/office/requests/remarket/:status_id?",
    name: "officeReqRemarket",
    meta: { layout: "main", title: "Заявки без ремонта" },
    component: () => import("@/views/office/requests/ClientRequestList.vue"),
    props: { remarket: true },
  },
  {
    path: "/office/requests/remonts/:status_id?/:stage_id?",
    name: "officeRemontList",
    meta: { layout: "main", title: "Ремонты" },
    component: () => import("@/views/office/requests/RemontList.vue"),
  },
  // okk/check-list-detail — проверка этапа ОКК (сюда вела ссылка из письма system/redirect-email для роли ОКК);
  // старый адрес Office тоже открывает страницу
  {
    path: "/office/requests/okk-check/:remont_id",
    alias: "/okk/check-list-detail/remont_id/:remont_id",
    name: "officeOkkCheck",
    meta: { layout: "main", title: "Чек листы детально" },
    component: () => import("@/views/office/requests/OkkCheck.vue"),
  },
  // dict/analog-material-accept-form — согласование аналога; ссылку со старым адресом пишет в карточку канбана
  // public.upd_analog_accept (относительный href — в канбане My Space откроется этот же маршрут)
  {
    path: "/office/requests/analog-accept/:analog_id/:client_request_id",
    alias: "/dict/analog-material-accept-form/analog_id/:analog_id/client_request_id/:client_request_id",
    name: "officeAnalogAccept",
    meta: { layout: "main", title: "Согласование альтернативы с клиентом" },
    component: () => import("@/views/office/requests/AnalogAccept.vue"),
  },
];
